import { render, staticRenderFns } from "./WarnList.vue?vue&type=template&id=59d387be&scoped=true&"
import script from "./WarnList.vue?vue&type=script&lang=js&"
export * from "./WarnList.vue?vue&type=script&lang=js&"
import style0 from "./WarnList.vue?vue&type=style&index=0&id=59d387be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d387be",
  null
  
)

export default component.exports